import { Validator } from './validator';
import { AdSlot } from '../../entities/ad-slot';
import {
  AdSlotConstraintValidatorInterface,
} from '../../interfaces/components/validator/ad-slot-constraint-validator.interface';
import { Injectable, MultiInject } from '../dependency-injection/decorators';

@Injectable()
export class AdSlotRenderValidator extends Validator {
  public constructor (
    @MultiInject('AdSlotConstraintValidator') private readonly adSlotConstraintValidators: AdSlotConstraintValidatorInterface[],
  ) {
    super();
  }

  public override validate (adSlot: AdSlot): Promise<boolean> | boolean {
    if (!adSlot.getId()) {
      return false;
    }

    if (!super.validate(adSlot)) {
      return false;
    }

    return adSlot.getConstraints()
      .every((constraint) => this.adSlotConstraintValidators
        .filter((validator) => validator.supports(constraint))
        .every((validator) => validator.validate(constraint)))
    ;
  }
}
